import {
  HR_APPROVAL,
  HR_APPROVALS_DEFAULT_STATUS,
  INITIAL_APPLICATION
} from '@/utils/constants';

export default function () {
  return {
    approvals: [],
    approvalsLoading: false,
    approval: { ...HR_APPROVAL },
    approvalSnapshot: { ...HR_APPROVAL },
    approvalLoading: false,
    approvalUpdating: false,
    approvalSaving: undefined,
    quotePDFHref: undefined,
    loadingQuotePDF: false,
    loadingContractPdf: false,
    hrApprovalDenyOpen: false,
    hrApprovalsStatus: HR_APPROVALS_DEFAULT_STATUS,
    hrApprovalsType: undefined,
    application: { ...INITIAL_APPLICATION },
    openingContractAgreement: undefined
  };
}
